import React, {Component} from 'react';
import {connect} from "react-redux";
import {fetchQuestionAnswerRevisions} from "../../actions/questionAnswersRevisions";
import CenteredDots from "../General/centeredDots";
import FormGroupPlainText from "../formGroupPlainText";
import moment from "moment";
import { mapRevisionItemToValue} from "../../helpers/questions/functions";
import _ from "lodash";
import {APPLICATION_OPPONENT_ENUM, MEDICAL_EXPERT_FEES_ENUM} from "../../helpers/variables";
import CustomLink from "../General/link/customLink";

class FormQuestionAnswerRevisions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 2
        }
    }

    componentDidMount() {
        if(
            this.props.application
            && this.props.application.id
            && this.props.historyItem
            && this.props.historyItem.values
            && this.props.historyItem.values.id
            && this.props.historyItem.editingSetting
            && this.props.historyItem.editingSetting.id
        ) {
            let entityId = 0;
            if(this.props.historyItem.editingSetting.tableName === "Application"){
                entityId = 0;
            } else if(this.props.historyItem.editingSetting.questionId) {
                entityId = this.props.historyItem.values.id
            } else if(this.props.historyItem.editingSetting.tableName === "ApplicationOpponent"){
                entityId = this.props.historyItem.entityId;
            } else if(this.props.historyItem.editingSetting.tableName === "ApplicationMedicalExpertFees"){
                entityId = this.props.historyItem.entityId;
            }

            this.props.fetchQuestionAnswerRevisions({
                applicationId: this.props.application.id,
                editingSettingId: this.props.historyItem.editingSetting.id,
                entityId: entityId //todo: handle questions, opponent, fees and fields as well
            })
        }
    }

    viewMore = () => {
        this.setState({page: this.state.page + 1})
    };

    viewLess = () => {
        this.setState({page: this.state.page > 1 ? (this.state.page - 1) : this.state.page })
    };

    getRevisionItems = () => {
        const items = [];
        if(!this.props.applicationAnswerRevisionItem.applicationAnswerRevisionsDtos){
            return items;
        }

        let revItems = this.props.applicationAnswerRevisionItem.applicationAnswerRevisionsDtos;
        if(this.props.historyItem.editingSetting.tableName === "ApplicationOpponent"){
            revItems = revItems
                .filter(item => item.applicationAnswerRevisionItemDtos[0].columnName === APPLICATION_OPPONENT_ENUM[this.props.historyItem.values.machineName]);
        }

        revItems.forEach(revision => {
            if(!this.props.historyItem.editingSetting || !this.props.historyItem.values){
                return {}
            }

            let change = "";
            let name = "";
            change = mapRevisionItemToValue(revision.applicationAnswerRevisionItemDtos[0]);
            //todo: handle fields
            if(this.props.historyItem.editingSetting.tableName === "Application"){
                if(this.props.historyItem.editingSetting.columnName === "WorkSourceId"){
                    const option = this.props.solicitorGroupWorkSources.find(i => (
                        i.id
                        && change
                        && change.toString() === i.id.toString()
                    ));
                    change = option ? option.name : change;
                }
            }

            // handle questions
            if(this.props.historyItem.editingSetting.questionId){
                if(this.props.historyItem.values.inputType === "drop down"){
                    const selectedOption = this.props.historyItem.values.options.find( o => {return (
                        o.id
                        && change
                        && o.id.toString() === change.toString()
                    )});
                    change = selectedOption ? selectedOption.name : change;
                }
            }

            // handle opponents
            if(this.props.historyItem.editingSetting.tableName === "ApplicationOpponent"){
                if(this.props.historyItem.values.inputType === "drop down"){
                    const selectedOption = this.props.historyItem.values.options.find( o => {return (
                        o.id
                        && change
                        && o.id.toString() === change.toString()
                    )});
                    change = selectedOption ? selectedOption.name : "";
                }
            }

            // handle fees
            if(this.props.historyItem.editingSetting.tableName === "ApplicationMedicalExpertFees"){
                if(revision.applicationAnswerRevisionItemDtos[0].columnName === "BreachCausationCpId"){
                    const option = this.props.breachCausationCpOptions.find(i => (
                        i.id
                        && change
                        && i.id.toString() === change.toString()
                    ));
                    change = option ? option.name : change;
                }
                const fee  = MEDICAL_EXPERT_FEES_ENUM[revision.applicationAnswerRevisionItemDtos[0].columnName];
                name = fee ? fee.name : name;
            }


            if( !(this.props.historyItem.editingSetting.tableName === "ApplicationOpponent" && !change) ) {
                items.push({
                    date: moment(revision.revisionDate).format("DD/MM/YYYY HH:mm:ss"),
                    change: change,
                    name: name ? name : null
                })
            }

        });
        return _.chain(items)
            .orderBy(i => i.date , "desc")
            .value();
    };

    render() {
        const {historyItem, fetchingRevisionItem} = this.props;
        if(fetchingRevisionItem){
            return (
                <div className={"col-sm-12"}>
                    <CenteredDots/>
                </div>
            )
        }

        const revisionItems = this.getRevisionItems();
        const reachedBottom = revisionItems.length <= (this.state.pageSize * this.state.page);
        return (
            <div>
                <div className={"form-horizontal"}>
                    {
                        this.props.historyItem.editingSetting.tableName === "ApplicationMedicalExpertFees" ?
                            <div>
                                <div className={"form-group"}>
                                    <div className={"col-sm-8 col-sm-offset-4"}>
                                        <div className={"row"}>
                                            <div className={"col-sm-6"}><strong>Change</strong></div>
                                            <div className={"col-sm-6"}><strong>Date Changed</strong></div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    revisionItems
                                        .slice(0, (this.state.page * this.state.pageSize) )
                                        .map((item, index) => (
                                            <FormGroupPlainText
                                                key={index}
                                                RightWrapper={this.props.rightClassName}
                                                rightData={this.props.rightData}
                                                leftWrapper={"col-sm-4"}
                                                InputWrapper={"col-sm-8"}
                                                Label={item.name}
                                                Text={(
                                                    <div className={"row"}>
                                                        <div className={"col-sm-6"}>{item.change}</div>
                                                        <div className={"col-sm-6"}>{item.date}</div>
                                                    </div>
                                                )}
                                            />
                                        ))
                                }

                            </div>
                            :
                            <FormGroupPlainText
                                RightWrapper={this.props.rightClassName}
                                rightData={this.props.rightData}
                                leftWrapper={"col-sm-4"}
                                InputWrapper={"col-sm-8"}
                                Label={historyItem.values.name}
                                Text={(
                                    <div>
                                        <div className={"row"}>
                                            <div className={"col-sm-6"}><strong>Change</strong></div>
                                            <div className={"col-sm-6"}><strong>Date Changed</strong></div>
                                        </div>
                                        {
                                            revisionItems
                                                .slice(0, (this.state.page * this.state.pageSize) )
                                                .map((item, index) => (
                                                    <div key={index} className={"row"}>
                                                        <div className={"col-sm-6"}>{item.change}</div>
                                                        <div className={"col-sm-6"}>{item.date}</div>
                                                    </div>
                                                ))
                                        }
                                    </div>
                                )}
                            />
                    }
                    {!reachedBottom && (
                        <div className={"form-group"}>
                            <div className={"col-sm-8 col-sm-offset-4"}>
                                <CustomLink
                                    label={"See more"}
                                    onClick={this.viewMore}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        applicationAnswerRevisionItem: state.questionAnswersRevisions.questionAnswerRevisions,
        fetchingRevisionItem: state.questionAnswersRevisions.fetchingQuestionAnswerRevisions,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetchQuestionAnswerRevisions: (payload) => {
            dispatch(fetchQuestionAnswerRevisions(payload))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(FormQuestionAnswerRevisions);
